module.exports = __webpack_public_path__ + "img/pg4-article3-bg.0c749c27.png";